"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isTokensValid = function isTokensValid(tokenData) {
  // do some basic validation on the tokenData
  if (_lodash.default.isNil(tokenData) || _lodash.default.isNil(tokenData.accessToken) || _lodash.default.isNil(tokenData.idToken)) {
    return false;
  }

  var accessToken = tokenData.accessToken,
      idToken = tokenData.idToken; // decode the tokens and get their expiration times

  var decodedAccessToken;
  var decodedIdToken;

  try {
    decodedAccessToken = (0, _jwtDecode.default)(accessToken);
    decodedIdToken = (0, _jwtDecode.default)(idToken);
  } catch (err) {
    // if we throw while decoding return false
    return false;
  }

  var accessTokenExp = decodedAccessToken.exp;
  var idTokenExp = decodedIdToken.exp; // get the current time as epoch

  var epochNow = Math.floor(new Date().getTime() / 1000); // if either of the tokens are invalid, return false

  if (accessTokenExp < epochNow || idTokenExp < epochNow) {
    return false;
  }

  return true;
};

var _default = isTokensValid;
exports.default = _default;